import React from "react"
import PropTypes from "prop-types"
import { Flex } from "datastory-shared/ui"

import { Item } from "./Item"

export const TagGroup = ({ categories, ...props }) => {
  const sortedCategories = [
    ...categories,
    { local_id: "all", og_name: [{ i18n: "All" }] },
  ].sort((a, b) => (a.local_id > b.local_id ? 1 : -1))

  return (
    <Flex justifyContent={"center"} flexWrap={"wrap"}>
      {sortedCategories.map(i => (
        <Item key={i.local_id} {...i} {...props} />
      ))}
    </Flex>
  )
}

TagGroup.propTypes = {
  screenWidth: PropTypes.number,
  categories: PropTypes.array,
}
